import store from "../../../store";
import uber_export from './uber_export.vue';

window.uber_export =  new Vue({
    store,
    el: 'div#uber_export',

    name : "uber_export",
    data () {
        return {

        }
    },
    created () {

    },
    components : {
        uber_export,
    }
});
